$(document).ready(function(){
  var main = $('.blog-slider-section');
  main.each( function() {
    var slider_blockid = $(this).data('blockid');
    var slider_count = $('#shopify-section-'+slider_blockid+ ' ul.blog-slider').data('count');
    
    if ($(window).width() >= 1024) {
      $('#shopify-section-'+slider_blockid+ ' .blog-slider').slick({
        slidesToShow: slider_count,
        slidesToScroll: 1,
        arrows: true,
        dots:false,
        infinite: true,
        centerMode: false,
        prevArrow:'<button type="button" class="slick-prev" aria-label="Previous slide"><svg class="icon icon-prev" viewBox="0 0 21 21"><path fill="#0C3D37" d="M15.3,20.7c-0.3,0-0.5-0.1-0.7-0.3l-9.9-9.9l9.9-9.9c0.4-0.4,1-0.4,1.4,0s0.4,1,0,1.4l-8.5,8.5L16,19 c0.4,0.4,0.4,1,0,1.4C15.8,20.6,15.6,20.7,15.3,20.7z"/></svg></button>',
    	nextArrow:'<button type="button" class="slick-next" aria-label="Next slide"><svg class="icon icon-next" viewBox="0 0 21 21"><path fill="#0C3D37" d="M5.7,0.3c0.3,0,0.5,0.1,0.7,0.3l9.9,9.9l-9.9,9.9c-0.4,0.4-1,0.4-1.4,0s-0.4-1,0-1.4l8.5-8.5L5,2 C4.6,1.6,4.6,1,5,0.6C5.2,0.4,5.4,0.3,5.7,0.3z"/></svg></button>'
      });
    }    
  });
});